import React, { useState } from 'react';
import clsx from 'clsx';

import { AppTheme, BaseComponentProps } from '@utils/types/baseComponents';
import { Check } from '@assets/icons';

import styles from './styles.module.scss';

type Props = {
  label: string;
  onChange: (checked: boolean) => void;
  value: boolean;
  variant: 'primary' | 'secondary' | 'newGreen' | AppTheme;
  withRoundCorners?: boolean;
} & BaseComponentProps;

const Checkbox = (props: Props) => {
  const {
    label,
    containerStyle,
    onChange,
    value,
    variant,
    withRoundCorners = false,
  } = props;

  const onClick = () => {
    onChange(!value);
  };

  return (
    <div className={clsx([styles.container, containerStyle])} onClick={onClick}>
      <div
        className={clsx([
          styles.checkBox,
          value && styles.checked,
          styles[`variant${variant}`],
          withRoundCorners && styles.roundCorners,
        ])}
      >
        <Check style={{ opacity: value ? 1 : 0 }} />
      </div>
      <label>{label}</label>
    </div>
  );
};

Checkbox.defaultProps = {
  label: 'Label',
  value: false,
  variant: 'primary',
  onChange: (_checked: boolean) => {},
};

export default Checkbox;
